import type { Eigenwoningforfaitschijf } from "@/models/domain/Eigenwoningforfaitschijf";
import type { Parameter } from "@/models/Parameter";

export const forfaitSchijven: Parameter<Eigenwoningforfaitschijf[]> = {
	values: {
		"2021-01-01": {
			metadata: {
				reference:
					"https://web.archive.org/web/20210615101723/https://www.belastingdienst.nl/wps/wcm/connect/nl/koopwoning/content/hoe-werkt-eigenwoningforfait",
			},
			value: [
				{ tot: 12_500, forfait: 0 },
				{ vanaf: 12_500, tot: 25_000, forfait: 0.002 },
				{ vanaf: 25_000, tot: 50_000, forfait: 0.003 },
				{ vanaf: 50_000, tot: 75_000, forfait: 0.004 },
				{ vanaf: 75_000, tot: 1_110_000, forfait: 0.005 },
				{
					vanaf: 1_110_000,
					forfait: (wozwaarde: number) => {
						const floor = 5_550;
						const wozwaardeExtra = wozwaarde - 1_110_000;
						const wozPercentage = 0.0235;

						return floor + wozwaardeExtra * wozPercentage;
					},
				},
			],
		},
		"2022-01-01": {
			metadata: {
				reference:
					"https://web.archive.org/web/20220726013949/https://www.belastingdienst.nl/wps/wcm/connect/nl/koopwoning/content/hoe-werkt-eigenwoningforfait",
			},
			value: [
				{ tot: 12_500, forfait: 0 },
				{ vanaf: 12_500, tot: 25_000, forfait: 0.0015 },
				{ vanaf: 25_000, tot: 50_000, forfait: 0.0025 },
				{ vanaf: 50_000, tot: 75_000, forfait: 0.0035 },
				{ vanaf: 75_000, tot: 1_130_000, forfait: 0.0045 },
				{
					vanaf: 1_130_000,
					forfait: (wozwaarde: number) => {
						const floor = 5085;
						const wozwaardeExtra = wozwaarde - 1_130_000;
						const wozPercentage = 0.0235;

						return floor + wozwaardeExtra * wozPercentage;
					},
				},
			],
		},
		"2023-01-01": {
			metadata: {
				reference:
					"https://web.archive.org/web/20220726013949/https://www.belastingdienst.nl/wps/wcm/connect/nl/koopwoning/content/hoe-werkt-eigenwoningforfait",
			},
			value: [
				{ tot: 12_500, forfait: 0 },
				{ vanaf: 12_500, tot: 25_000, forfait: 0.001 },
				{ vanaf: 25_000, tot: 50_000, forfait: 0.002 },
				{ vanaf: 50_000, tot: 75_000, forfait: 0.0025 },
				{ vanaf: 75_000, tot: 1_200_000, forfait: 0.0035 },
				{
					vanaf: 1_200_000,
					forfait: (wozwaarde: number) => {
						const floor = 4200;
						const wozwaardeExtra = wozwaarde - 1_200_000;
						const wozPercentage = 0.0235;

						return floor + wozwaardeExtra * wozPercentage;
					},
				},
			],
		},
		"2024-01-01": {
			value: [
				{ tot: 12_500, forfait: 0 },
				{ vanaf: 12_500, tot: 25_000, forfait: 0.001 },
				{ vanaf: 25_000, tot: 50_000, forfait: 0.002 },
				{ vanaf: 50_000, tot: 75_000, forfait: 0.0025 },
				{ vanaf: 75_000, tot: 1_310_000, forfait: 0.0035 },
				{
					vanaf: 1_310_000,
					forfait: (wozwaarde: number) => {
						const floor = 4585;
						const wozwaardeExtra = wozwaarde - 1_310_000;
						const wozPercentage = 0.0235;

						return floor + wozwaardeExtra * wozPercentage;
					},
				},
			],
		},
		"2025-01-01": {
			metadata: {
				reference:
					"https://www.rijksfinancien.nl/sites/default/files/rapporten/belastingplan-2025/pakket-belastingplan/Fiscale-sleuteltabel-2025.pdf",
			},
			value: [
				{ tot: 12_500, forfait: 0 },
				{ vanaf: 12_500, tot: 25_000, forfait: 0.001 },
				{ vanaf: 25_000, tot: 50_000, forfait: 0.002 },
				{ vanaf: 50_000, tot: 75_000, forfait: 0.0025 },
				{ vanaf: 75_000, tot: 1_330_000, forfait: 0.0035 },
				{
					vanaf: 1_330_000,
					forfait: (wozwaarde: number) => {
						const floor = 4655;
						const wozwaardeExtra = wozwaarde - 1_330_000;
						const wozPercentage = 0.0235;

						return floor + wozwaardeExtra * wozPercentage;
					},
				},
			],
		},
		"2026-01-01": {
			metadata: {
				reference:
					"https://www.rijksfinancien.nl/sites/default/files/rapporten/belastingplan-2025/pakket-belastingplan/Fiscale-sleuteltabel-2025.pdf",
			},
			value: [
				{ tot: 12_500, forfait: 0 },
				{ vanaf: 12_500, tot: 25_000, forfait: 0.001 },
				{ vanaf: 25_000, tot: 50_000, forfait: 0.002 },
				{ vanaf: 50_000, tot: 75_000, forfait: 0.0025 },
				{ vanaf: 75_000, tot: 1_340_000, forfait: 0.0035 },
				{
					vanaf: 1_340_000,
					forfait: (wozwaarde: number) => {
						const floor = 4690;
						const wozwaardeExtra = wozwaarde - 1_340_000;
						const wozPercentage = 0.0235;

						return floor + wozwaardeExtra * wozPercentage;
					},
				},
			],
		},
	},
};
